export default __webpack_public_path__ + "static/media/DocumentationStandards_commits.fb292dad.png";